import React from 'react'
import GoogleSlidesCaseStudy from '../templates/GoogleSlidesCaseStudy'
import SlideDeck from '../../../assets/decks/publix_deli_master.pdf'
const Work = () => (
  <GoogleSlidesCaseStudy
    pageTitle="Deli Order Experience"
    date="2025"
    role="Lead Designer"
    company="Publix"
    presentationId="2PACX-1vRR3ky_bc-zC5htsTAbZXxmpptkFCActUXDp9r-MvhbmCXqgQpguSahF1dbDFR7ww"
    pdfLink={SlideDeck}
  />
)

export default Work;
